'use strict';

/** @type {import('./max')} */
module.exports = Math.max;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/math-intrinsics/max.js
// module id = 5630
// module chunks = 0